// main.ts
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router/index'
import { createPinia } from 'pinia'
import {LazyLoad} from '@/directives/index'
import  piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import zhLocale from 'element-plus/es/locale/lang/zh-cn'
import '@fortawesome/fontawesome-free/css/all.min.css'
const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)
app.use(pinia);
app.use(ElementPlus, {
  locale: zhLocale
})
app.use(router)
app.use(LazyLoad)
app.mount('#app')
// app.use(ElementPlus)